import { render, staticRenderFns } from "./jenkins.vue?vue&type=template&id=895ddd06&scoped=true&"
import script from "./jenkins.vue?vue&type=script&lang=js&"
export * from "./jenkins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895ddd06",
  null
  
)

export default component.exports